<template>
  <Toast/>
  <div class="p-grid">
    <div v-if="groupFilter" class="p-grid alarm-table-filters">
      <div class="p-col-12 p-md-6 p-lg-3 nowrap">
        <label class="filter-label">{{ _t('label_status') }}</label>
        <MultiSelect
            v-model="alarmFilters.statuses"
            :options="alarmJobStatuses"
            :placeholder="_t('ALARMSTATUS')"
            :showClear="true"
            class="p-inputtext p-p-0 p-ml-2 filter-input"
            display="chip"
            style="width: 160px;"
        >
          <template #value="slotProps">
            <div v-for="option of slotProps.value" :key="option">
              <span>{{ _t(option) }}</span>
            </div>
            <template v-if="!slotProps.value || slotProps.value.length === 0">
              {{ _t('label_status') }}
            </template>
          </template>
          <template #option="slotProps">
            <div class="p-multiselect-car-option">
              <span>{{ _t(slotProps.option) }}</span>
            </div>
          </template>
        </MultiSelect>
      </div>
      <div class="p-col-12 p-md-6 p-lg-3 nowrap alarm-point-hidden">
        <label class="filter-label">{{ _t('label_object_name') }}</label>
        <InputText v-model="alarmFilters.alarmName" :placeholder="_t('label_search_by_name')"
                   class="p-ml-2 filter-input" style="width: 160px;"/>
      </div>
      <div class="p-col-12 p-md-6 p-lg-3 nowrap alarm-point-hidden">
        <label class="filter-label">{{ _t('label_alarm_id') }}</label>
        <InputText v-model="alarmFilters.alarmPointId" :placeholder="_t('label_search_by_alarm_point_ID')"
                   class="p-ml-2 filter-input"
                   style="width: 160px;"/>
      </div>
      <div class="p-col-12 p-md-6 p-lg-3 nowrap alarm-point-hidden">
        <label class="filter-label">{{ _t('label_system_id') }}</label>
        <InputText v-model="alarmFilters.systemId" :placeholder="_t('label_search_by_system_ID')"
                   class="p-ml-2 filter-input"
                   style="width: 160px;"/>
      </div>
      <div class="p-col-12 p-md-6 p-lg-3 nowrap">
        <label class="filter-label">{{ _t('label_started') }}</label>
        <ExtendedCalendar v-model:date="durationFilters" :inputStyles="{width: '160px'}" class="p-ml-2 filter-input" orientation="left" style=""/>
      </div>
      <div class="p-col-12 p-md-6 p-lg-3 nowrap">
        <label class="filter-label">{{ _t('label_Last_hours') }}</label>
        <InputText
            v-model="hoursDuration"
            :disabled="durationFilters.start !== null || durationFilters.end !== null"
            :min="0"
            :placeholder="_t('label_last_hours')"
            class="p-ml-2 filter-input"
            style="width: 160px;"
        />
      </div>
      <div class="p-col-12 p-md-6 p-lg-3 nowrap">
        <label class="filter-label">{{ _t('filter_triggeredby') }}</label>
        <Dropdown
            v-model="alarmFilters.triggeredBy"
            :options="users"
            :placeholder="_t('filter_triggeredby')"
            :showClear="true"
            class="p-ml-2 filter-input"
            clearIcon="pi pi-times"
            optionLabel="label"
            optionValue="value"
            style="width: 160px;"
        ></Dropdown>
      </div>
      <div class="p-col-12 p-md-6 p-lg-3 nowrap">
        <label class="filter-label"></label>
        <Button :label="_t('Clear')" class="p-ml-2 p-button-outlined p-button-danger"
                @click="clearAllFilters()"/>
      </div>
      <div class="p-col-12">
        <label>
          {{ _t('label_participants') }}
        </label>
        <SelectParticipant :active-tab="this.activeTab" :filters-prefix="this.filtersPrefix" :multiple="true"
                           :participants-data="this.participantsByPrefix" class="p-ml-2" @change="setParticipant"/>
      </div>
    </div>
    <transition name="slide-fade">
      <div :class="`style ${selectedJobId ? 'p-lg-5 p-md-12 ' : 'p-lg-12 p-md-12 p-sm-12'}`">
        <DataTable
            class="p-datatable-sm"
            v-if="activeTab !== 4"
            v-model:selection="selectedAlarmTableItem"
            :globalFilterFields="['alarmPointName', 'alarmJobStartDate']"
            :lazy="true"
            :loading="loading"
            :page="currentPage"
            :paginator="activeTab !== 4"
            :paginatorTemplate="'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink'"
            :rowHover="true"
            :rows="alarmTableRows"
            :rowsPerPageOptions="pageSize"
            :showFilterMatchModes="false"
            :totalRecords="totalRecords"
            :value="alarms"
            responsiveLayout="scroll"
            :scrollHeight="tableHeight"
            selectionMode="single"
            @page="selectTablePage($event)"
            @row-click="triggerGetAlarm($event.data);"
            scrollable
            stripedRows
            :style="{ '--row-height': '20px' }"
        >
          <template #paginatorstart>
            <div class="flex items-center gap-2 pt-2">
              <label class="text-sm font-medium whitespace-nowrap">
                {{ _t('primefaces.paginator.aria.ROWS_PER_PAGE') }}
              </label>
              <Dropdown
                  v-model="alarmTableRows"
                  :options="pageSize"
                  class="w-32"
              />
            </div>
          </template>
          <template #paginatorend>
          </template>
          <template #empty>
            {{ _t('label_no_alarms_found') }}
          </template>
          <template #loading>
            {{ _t('label_Loading_alarms_data') }}
          </template>
          <span v-if="selectedJobId === null">
            <Column
                v-for="column in desktopColumns"
                :key="column.key"
                :field="column.field"
                :filterField="column.filterField"
                :filterMatchMode="column.filterMatchMode"
                :header="column.header ? (column.translateHeader ? _t(column.header) : column.header) : undefined"
                :headerClass="column.headerClass"
                :bodyClass="column.bodyClass"
                :hidden="!handleCheckRow(column.visibility)"
                :style="column.style"
            >
              <template #filter="{}">
                <InputText
                    v-if="column.key === 'triggeredBy'"
                    v-model="alarmFilters.triggeredBy"
                    :placeholder="_t('filter_triggeredby')"
                    class="p-column-filter"
                    @keydown.enter="filterCallback()"
                />
                <ExtendedCalendar
                    v-else-if="column.key === 'started'"
                    v-model:date="durationFilters"
                    :inputStyles="{width: '160px'}"
                    orientation="left"
                />
                <div v-else-if="column.key === 'ended'" class="p-inputgroup">
                  <p class="p-inputgroup-addon p-mb-0">Last hours</p>
                  <InputNumber v-model="hoursDuration" placeholder="Last hours..." style="height: 2rem;"/>
                </div>
              </template>
              <template #body="{data}">
                <div v-if="column.key === 'status'" class="p-d-flex">
                  <div class="p-d-inline-flex" style="width:1rem;">
                    <Button
                        :style="'right:20px; border: none; border-radius: 5px; margin:2px; display: inline-block; background-color: ' + associateColor(data.jobStatusColor)"
                        type="button"
                    />
                  </div>
                  <div class="p-d-inline-flex" style="align-items:center;">
                    <strong class="p-pr-2">{{ _t(data.alarmJobStatus) }}</strong>
                  </div>
                </div>
                <div v-else-if="column.key === 'status2'" class="p-d-inline-flex" style="align-items:center;">
                  <p v-tooltip.bottom="_t(data.alarmPointStatus)" class="alarm-table-ellipsis">
                    {{ _t(data.alarmPointStatus) }}
                  </p>
                </div>
                <div
                    v-else-if="column.key === 'alarmName'"
                    v-tooltip.bottom="data.alarmPointName"
                    class="p-d-flex"
                    style="align-items:center; min-width: 0;"
                >
                  <div class="p-d-inline-flex">
                    <Button
                        :style="`border: none; border-radius: 5px; margin:5px 5px 5px 0; padding: 0.1rem 0.2rem; display: inline-block; background-color: ${data?.icon?.color || '#989898'}`"
                        class="no-transition"
                        type="button"
                        @click="selectedAlarmTableItem = data; triggerGetAlarm(data.alarmJobId);"
                    >
                      <i :class="data?.icon?.name || 'mdi mdi-alert-outline'" style="font-size: 16px !important;"/>
                    </Button>
                  </div>
                  <div class="alarm-table-flex-ellipsis">{{ data.alarmPointName }}</div>
                </div>
                <div v-else-if="column.key === 'triggeredBy'" class="p-d-flex" style="flex-wrap: wrap;">
                  <p class="alarm-table-ellipsis"><strong>{{ displayTriggeredBy(data.triggeredBy) }}</strong></p>
                </div>
                <div
                    v-else-if="column.key === 'alarmId'"
                    v-tooltip.bottom="data.alarmPointId"
                    class="p-d-flex"
                    style="align-items:center; min-width: 0;"
                >
                  <p class="alarm-table-flex-ellipsis">{{ data.alarmPointId }}</p>
                </div>
                <template v-else-if="column.key === 'ended'">
                  <img v-if="!data.alarmJobEndDate" src="assets/layout/images/flag.png" style="width: 1.5rem; height: 20px;"/>
                  <p v-else>{{ data.alarmJobEndDate }}</p>
                </template>
                <template v-else>{{ data[column.field] }}</template>
              </template>
            </Column>
          </span>
          <span v-else>
            <Column field="alarmPointName" :header="_t('label_Alarm_name')" :style="{minWidth: '12rem', flexGrow: 3}">
              <template #filter="{}">
                <div class="compact-filter">
                  <Dropdown v-model="alarmFilters.statuses" :options="alarmJobStatuses"
                            :placeholder="_t('ALARMSTATUS')" class="compact-filter-item"/>
                  <InputText v-model="alarmFilters.alarmName" :placeholder="_t('label_search_by_name')"
                             class="compact-filter-item"/>
                  <InputText v-model="alarmFilters.alarmPointId" :placeholder="_t('label_search_by_alarm_point_ID')"
                             class="compact-filter-item" @keydown.enter="filterCallback()"/>
                  <InputText v-model="alarmFilters.triggeredBy" :placeholder="_t('filter_triggeredby')"
                             class="compact-filter-item" @keydown.enter="filterCallback()"/>
                </div>
              </template>
              <template #body="{data}">
                <div class="row-cell">
                  <Button
                      :style="`font-size: 2rem; border: none; border-radius: 5px; padding: .3rem .4rem; background-color: ${data?.icon?.color || '#989898'}; border-color: ${data?.icon?.color || '#989898'};`"
                      class="no-transition p-mr-2"
                      type="button"
                  >
                    <i :class="data?.icon?.name || 'mdi mdi-alert-outline'"/>
                  </Button>
                  <div class="row-cell-text">
                    <strong v-tooltip.bottom="data.alarmPointName" class="row-truncate">{{ data.alarmPointName }}</strong>
                    <span v-tooltip="data.alarmPointId" class="row-truncate row-sub">{{ data.alarmPointId }}</span>
                    <span v-if="data.triggeredBy" v-tooltip="displayTriggeredBy(data.triggeredBy)" class="row-truncate row-sub">{{ displayTriggeredBy(data.triggeredBy) }}</span>
                  </div>
                </div>
              </template>
            </Column>
            <Column field="alarmJobStatus" :header="_t('label_status')" :style="{minWidth: '9rem', flexGrow: 2}">
              <template #filter="{}">
                <div class="compact-filter">
                  <ExtendedCalendar :inputStyles="{width: '100%'}" v-model:date="durationFilters" orientation="left"/>
                  <InputText v-model="alarmFilters.systemId" :placeholder="_t('label_search_by_system_ID')"
                             class="compact-filter-item" @keydown.enter="filterCallback()"/>
                </div>
              </template>
              <template #body="{data}">
                <div class="row-status">
                  <div class="row-status-badges">
                    <Badge v-if="data.alarmJobStatus" :style="'background-color:' + associateColor(data.jobStatusColor)"/>
                    <span v-if="data.alarmJobStatus" :style="'color:' + associateColor(data.jobStatusColor)" class="row-truncate">
                      <strong>{{ _t(data.alarmJobStatus) }}</strong>
                    </span>
                    <Badge v-if="data.alarmPointStatus" :style="'background-color:' + associateColor()"/>
                    <span v-if="data.alarmPointStatus" :style="'color:' + associateColor()" class="row-truncate">
                      <strong>{{ _t(data.alarmPointStatus) }}</strong>
                    </span>
                  </div>
                  <p class="p-m-0 row-date">
                    <i class="mdi mdi-play-outline row-date-icon"/>
                    {{ data.alarmJobStartDate }}
                  </p>
                  <p class="p-m-0 row-date">
                    <i :class="data.alarmJobEndDate ? 'mdi mdi-bookmark-outline' : 'mdi mdi-bookmark'"
                       :style="{ color: data.alarmJobEndDate ? 'black' : 'red' }"
                       class="row-date-icon"/>
                    {{ data.alarmJobEndDate }}
                  </p>
                </div>
              </template>
            </Column>
          </span>
        </DataTable>
      </div>
    </transition>

    <div class="style p-md-12 p-lg-7">
      <history-singe-item ref="singleItemData" v-model:selected-job-id="selectedJobId"
                          :alarm-type="this.selectedTab < 7 ? this.selectedTab : 0" :hasTriggerProps="false">
      </history-singe-item>
    </div>
  </div>
  <Dialog v-model:visible="selectParticipantsDlg">
    <template #header>
      <h3>{{ _t('label_participants') }}</h3>
    </template>

    <p>{{ _t('primefaces.datatable.aria.FILTER_BY') }}: {{ _t('label_participants') }}</p>
    <ParticipantSelector v-model="participantsByPrefix" :allowParticipantGroups="false" scrollHeight="40vh"
                         style="width:30vw;"/>
    <template #footer>
      <Button :label="_t('Cancel')" class="p-button-outlined p-button-secondary"
              @click="selectParticipantsDlg = false"/>
      <Button :label="_t('Save')" autofocus class="p-button-success" @click="selectParticipantsDlg = false"/>
    </template>
  </Dialog>
</template>

<script>

import {getAll, getHistory, getHistoryByAlarm} from '@/api/alarmTable'
import item from '@/views/alarm_table/alarms/item'
import {associateColor} from '@/service/helper/styleHelper'
import {mapActions, mapGetters} from 'vuex'
import ExtendedCalendar from '@/components/ExtendedCalendar'
import SelectParticipant from '@/components/SelectParticipant'
import {getList} from '@/api/list'
import {getTableFilters, setTableFilters} from '@/api/tableFilters'
import router from '@/router'
import {createMemoizedStateManager} from '@/state/memoizedStateManager'
import {createIntervalController} from '@/utils/intervalController'
import {buildAlarmRowsDto} from '@/views/alarm_table/alarms/utils/alarmDtos'
import {
  ALARM_REFRESH_INTERVAL,
  DEFAULT_HISTORY_DURATION_HOURS,
  EXTERNAL_HISTORY_DURATION_FILTER,
  alarmStorageKey,
  buildTableFiltersPayload,
  createAlarmJobStatuses,
  createAlarmTableFilterKeys,
  createDefaultAlarmFilters,
  createDefaultAlarmRow,
  createDefaultDurationFilters,
  createInitialDurationFilters,
  createPageSizeOptions,
  loadLocalAlarmFilters,
  readAlarmStorage,
  readAlarmTableRows,
  readStoredHoursDuration,
  saveLocalAlarmFilters,
} from '@/views/alarm_table/alarms/utils/alarmTableState'
import { getOrganizationSnapshot, setMultiOrganizations } from '@/state/organizationContext'
import { orgIdsToSelectedKeys } from '@/storage/organizationStorage'
import { REFERENCE_LOOKUP_PAGE_SIZE } from '@/constants/pagination'
import { createAlarmTableColumns, formatTriggeredBy } from '@/views/alarm_table/alarms/utils/alarmTableColumns'

function sameJsonValue(left, right) {
  return JSON.stringify(left ?? null) === JSON.stringify(right ?? null)
}

export default {
  name: 'alarms',
  components: {
    'historySingeItem': item,
    ExtendedCalendar,
    SelectParticipant,
  },
  props: {
    groupFilter: {
      type: Boolean,
      default: false,
    },
    activeTab: {
      type: Number,
      default: null,
    },
    orgFilter: {
      type: Array,
      default: () => [],
    },
    startImmediately: {
      type: Boolean,
      default: true,
    },
    filtersPrefix: {
      type: String,
      default: '',
    },
    alarmTableValues: {
      type: Array,
      default: () => [],
    },
    additionalId: {
      type: Number,
      default: null
    },
    isFirstSelected: {
      type: Boolean,
      default: false,
    }
  },
  emits: ['update:orgFilter', 'update:groupFilter', 'update:sortKey'],
  data() {
    return {
      loading: true,
      currentPage: 0,
      totalRecords: 0,
      selectedTab: this.activeTab || 0,
      alarmsIntervalController: null,
      alarms: [createDefaultAlarmRow()],
      canBeWatched: false,
      participants: [],
      participantsFilter: [],
      participantsByPrefix: [],
      tableDataKey: 'alarmId',
      alarmTableRows: readAlarmTableRows(),
      pageSize: createPageSizeOptions(),
      alarmJobStatuses: createAlarmJobStatuses(),
      alarmTableFilterKeys: createAlarmTableFilterKeys(),
      alarmFilterKey: '',
      alarmFilterValue: '',
      durationFilters: createInitialDurationFilters(this.filtersPrefix),
      alarmFilters: createDefaultAlarmFilters(),

      selectedAlarmTableItem: null,
      selectedJobId: null,
      hoursDuration: readStoredHoursDuration(this.filtersPrefix),
      orgFilterLocal: null,
      selectParticipantsDlg: false,
      checkTableFilterIntervalId: null,
      externalHistoryalarmId: null,
      users: [],
      referenceDataState: null,
    }
  },
  beforeUnmount() {
    this.alarmsIntervalController?.stop()
    clearInterval(this.checkTableFilterIntervalId)
    if (this.referenceDataState) {
      this.referenceDataState.dispose()
    }
    this.canBeWatched = false
  },
  watch: {
    orderByPriority() {
      this.currentPage = 0
      this.loading = true
      this.refreshAlarms();
    },
    sortKey() {
      this.currentPage = 0
      this.loading = true
      this.refreshAlarms();
    },
    alarmTableRows(alarmTableRows) {
      localStorage.setItem('alarmTableRows', alarmTableRows)
      this.currentPage = 0
      if (this.canBeWatched === true) {
        this.loading = true
        this.refreshAlarms();
      }
    },
    durationFilters(value) {
      if (value.start === null && value.end === null) {
        this.durationFilters.hours = this.hoursDuration
        this.durationFilters.option = 'HOURS_DURATION'
      }
      this.currentPage = 0
      if (this.canBeWatched === true) {
        this.loading = true
        this.refreshAlarms();
      }
    },
    alarmFilterValue() {
      this.currentPage = 0
      if (this.canBeWatched === true) {
        this.loading = true
        this.refreshAlarms();
      }
    },
    alarmFilters() {
      this.currentPage = 0
      if (this.canBeWatched === true) {
        this.loading = true
        this.refreshAlarms();
      }
    },
    orgFilterLocal() {
      this.currentPage = 0
      if (this.canBeWatched === true) {
        this.loading = true
        this.refreshAlarms();
      }
    },
    orgFilter(value) {
      this.orgFilterLocal = value
    },
    hoursDuration(value) {
      if (value > 0) {
        this.loading = true
        this.initTab(this.selectedTab, this.alarmFilters.alarmPointId, value);
      } else {
        this.hoursDuration = readStoredHoursDuration(this.filtersPrefix)
      }
    },
  },
  async mounted() {
    if (this.$route.query.alarmId) {
      this.selectedJobId = this.$route.query.alarmId
    }
    await this.getParticipants()
    await this.getUsers()
    const selectedOrgIds = getOrganizationSnapshot().multiOrgIds
    const storedOrgFilter = readAlarmStorage(this.filtersPrefix, 'orgFilter')
    if (!sameJsonValue(storedOrgFilter, selectedOrgIds)) {
      saveLocalAlarmFilters(this.filtersPrefix, {orgFilter: selectedOrgIds})
    }
  },
  created() {
    this.referenceDataState = createMemoizedStateManager({maxEntries: 4, ttl: 1000})
    this.alarmsIntervalController = createIntervalController()
    this.loadFilters()
    this.refreshAlarms();
    this.checkAlarmFilters()
  },
  computed: {
    ...mapGetters({
      selectedParticipants: 'participant/getSelectedParticipants',
    }),
    tableHeight() {
      if (this.groupFilter) {
        return 'calc(100vh - 415px)'
      } else {
        return 'calc(100vh - 273px)'
      }
    },
    desktopColumns() {
      return createAlarmTableColumns()
    },
  },
  methods: {
    ...mapActions({
      setSelectedParticipants: 'participant/setSelectedParticipants',
    }),
    displayTriggeredBy(value) {
      return formatTriggeredBy(value)
    },
    async handleSaveFilters() {
      const filters = buildTableFiltersPayload({
        durationFilters: this.durationFilters,
        alarmFilterValue: this.alarmFilterValue,
        alarmTableRows: this.alarmTableRows,
        alarmFilters: this.alarmFilters,
        currentPage: this.currentPage,
        orgFilter: this.orgFilter,
        participantsFilter: readAlarmStorage(this.filtersPrefix, 'participantsFilter'),
        sortKey: this.sortKey,
      })
      await setTableFilters(JSON.stringify(filters))
    },
    async clearAllFilters() {
      this.alarmFilters = createDefaultAlarmFilters()
      this.currentPage = 0
      this.durationFilters = createDefaultDurationFilters()
      this.hoursDuration = 23
      this.alarmFilterValue = ''
      const filters = buildTableFiltersPayload({
        durationFilters: this.durationFilters,
        alarmFilterValue: this.alarmFilterValue,
        alarmTableRows: this.alarmTableRows,
        alarmFilters: this.alarmFilters,
        currentPage: this.currentPage,
        orgFilter: this.orgFilter,
        sortKey: this.sortKey,
      })
      await setTableFilters(JSON.stringify(filters))
    },
    setParticipant() {
      this.participantsFilter = this.selectedParticipants
      this.refreshAlarms();
      localStorage.setItem(alarmStorageKey(this.filtersPrefix, 'participantsFilter'), JSON.stringify(this.selectedParticipants))
    },
    getParticipants() {
      return this.referenceDataState.memoize('participants', () => {
        return getList('PARTICIPANT', 0, '', REFERENCE_LOOKUP_PAGE_SIZE).then((response) => {
          return response.data.list.filter(function (item) {
            return item.login;
          })
        })
      }).then((participants) => {
        this.participants = participants
        this.loading = false
      })
    },
    getUsers() {
      return this.referenceDataState.memoize('users', () => {
        return getList('USER', 0, '', REFERENCE_LOOKUP_PAGE_SIZE, 1, true, 'login').then((response) => {
          return response.data.list.map((el) => ({value: el.login, label: `${el.login}`}))
        })
      }).then((users) => {
        this.users = users
        this.loading = false
      })
    },
    parseJobIdByType(data) {
      if (this.$route.query.alarmId) {
        return this.$route.query.alarmId
      }

      switch (this.selectedTab) {
        case 0:
          return data.alarmJobId
        case 1:
          return data.historyId
        case 2:
          return data.historyId
        case 30:
          router.push(`/alarm-table?tab=2&alarmId=${data.historyId}`)
          return null
        default:
          return null
      }
    },
    triggerGetAlarm(data) {
      this.selectedJobId = this.parseJobIdByType(data)
    },
    refreshAlarms() {
      if (this.startImmediately === true) {
        switch (parseInt(this.selectedTab)) {
          case 0:
            this.tableDataKey = 'alarmId'
            this.$emit('update:groupFilter', false);
            this.runWithInterval('getAllAlarms', ALARM_REFRESH_INTERVAL)
            break;
          case 1:
            this.tableDataKey = 'historyId'
            this.$emit('update:groupFilter', false);
            this.runWithInterval('getMyAlarms', ALARM_REFRESH_INTERVAL)
            break;
          case 2:
            this.tableDataKey = 'historyId'
            this.runWithInterval('getHistoryAlarms', ALARM_REFRESH_INTERVAL)
            break;
          case 30:
            this.tableDataKey = 'historyId'
            this.getHistoryByAlarmId(this.externalHistoryalarmId, null, EXTERNAL_HISTORY_DURATION_FILTER)
            break;
        }
      }
      this.canBeWatched = true
    },
    runWithInterval(method, interval = null) {
      this.alarmsIntervalController.run(method, () => this[method](), interval)
    },
    toggleSearch(event) {
      this.$refs.op.toggle(event);
    },
    applyAlarmListResponse(response, options = {}) {
      this.alarms = buildAlarmRowsDto(response.data.list)

      if (options.clearSelectedWhenEmpty && !this.alarms.length) {
        this.selectedJobId = null;
      }

      if (this.isFirstSelected === true && !this.selectedJobId && this.alarms.length > 0) {
        if (options.firstSelectedMode === 'active') {
          this.selectedJobId = parseInt(this.alarms[0].historyId) + 1
        }

        if (options.firstSelectedMode === 'history') {
          this.selectedJobId = this.alarms[0].historyId
        }
      }

      this.totalRecords = response.data.count
      this.saveFilters()
      this.loading = false
    },
    selectTablePage(item) {
      this.loading = true
      this.currentPage = item.page
      this.refreshAlarms();
    },
    onFilter() {
      this.loading = true
      this.refreshAlarms();
    },
    clearFilter() {
      this.alarmFilterValue = ''
    },
    getMyAlarms() {
      const participantsFilter = readAlarmStorage('my', 'participantsFilter')
      getHistory(
          this.currentPage,
          this.sortKey,
          this.alarmFilterValue,
          this.alarmTableRows,
          this.alarmFilters,
          this.orgFilter,
          this.durationFilters,
          this.orderByPriority,
          participantsFilter
      ).then((response) => {
        this.applyAlarmListResponse(response)
      })
    },
    getHistoryAlarms(customAlarmFilters = null, customDurationFilters = null) {
      const participantsFilter = readAlarmStorage('history', 'participantsFilter')
      this.durationFilters.hours = this.hoursDuration;
      getHistory(
          this.currentPage,
          this.sortKey,
          this.alarmFilterValue,
          this.alarmTableRows,
          customAlarmFilters ?? this.alarmFilters,
          this.orgFilter,
          customDurationFilters ?? this.durationFilters,
          this.orderByPriority,
          participantsFilter
      ).then((response) => {
        this.applyAlarmListResponse(response, {
          clearSelectedWhenEmpty: true,
          firstSelectedMode: 'history',
        })
      })
    },
    getHistoryByAlarmId(alarmId, customAlarmFilters = null, customDurationFilters = null) {
      const participantsFilter = readAlarmStorage('my', 'participantsFilter')
      this.externalHistoryalarmId = alarmId
      this.durationFilters.hours = this.hoursDuration;
      if (alarmId || this.additionalId) {
        getHistoryByAlarm(
            alarmId || this.additionalId,
            this.currentPage,
            this.alarmFilterKey.value,
            this.alarmFilterValue,
            this.alarmTableRows,
            customAlarmFilters ?? this.alarmFilters,
            this.orgFilter,
            customDurationFilters ?? this.durationFilters,
            participantsFilter
        ).then((response) => {
          this.applyAlarmListResponse(response, {
            clearSelectedWhenEmpty: true,
            firstSelectedMode: 'history',
          })
        })
      }
    },
    downloadFile(response, filename) {
      var newBlob = new Blob([response.data])
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }
      const data = window.URL.createObjectURL(newBlob);
      var link = document.createElement('a');
      link.href = data;
      link.download = filename;
      link.click();
      setTimeout(function () {
        window.URL.revokeObjectURL(data), 100
      })
    },
    getAllAlarms() {
      getAll(this.currentPage, this.sortKey, this.alarmFilterValue, this.alarmTableRows, this.alarmFilters, this.orgFilter, this.durationFilters, this.orderByPriority, this.participantsFilter)
          .then((response) => {
            this.applyAlarmListResponse(response, {
              firstSelectedMode: 'active',
            })
          })
    },
    associateColor,
    clearComponent(dropSelectedItem = false) {
      if (dropSelectedItem) {
        this.selectedAlarmTableItem = null;
        this.selectedJobId = null;
        this.alarmFilters = {
          ...this.alarmFilters,
          alarmPointId: '',
          statuses: [],
          systemId: null,
        }
        this.durationFilters = {
          ...this.durationFilters,
          start: null,
          end: null,
        }
        this.currentPage = 0
      }
      this.alarmsIntervalController?.stop();
    },
    initTab(id, alarmPointId = null, hoursDuration = DEFAULT_HISTORY_DURATION_HOURS) {
      this.selectedTab = id
      if (this.durationFilters.start === null && this.durationFilters.end === null) {
        this.hoursDuration = hoursDuration
        this.durationFilters.hours = hoursDuration
        this.durationFilters.option = 'HOURS_DURATION'
      } else {
        delete this.durationFilters.hours
        this.durationFilters.option = 'RANGE'
      }
      if (alarmPointId !== null) {
        this.alarmFilters.alarmPointId = alarmPointId
      }
      this.saveFilters()
      if (this.canBeWatched === true) {
        this.refreshAlarms();
        this.loading = false;
      }
    },
    checkAlarmFilters() {
      this.checkTableFilterIntervalId = setInterval(() => {
        if (JSON.stringify(this.alarmFilters) !== localStorage.getItem('af.' + this.filtersPrefix + '.alarmFilters')) {
          localStorage.setItem('af.' + this.filtersPrefix + '.alarmFilters', JSON.stringify(this.alarmFilters));
        }
      }, 1500);
    },
    loadFilters() {
      this.loadServerFilters()
      this.applyLocalFilters()
    },
    loadServerFilters() {
      if (this.filtersPrefix === 'my') {
        getTableFilters().then((res) => {
          if (res.data) {
            Object.keys(res.data).forEach((el) => {
              if (this.selectedTab === 1 && el !== 'orgFilter' && el !== 'sortKey' && el !== 'currentPage' && el !== 'participantsFilter') {
                this[el] = res.data[el]
              }

              if (el === 'multiOrgData') {
                const organizationState = getOrganizationSnapshot()
                const orgIds = this.orgFilterLocal?.length ? this.orgFilterLocal : organizationState.multiOrgIds
                setMultiOrganizations({
                  orgIds,
                  selectedKeys: orgIdsToSelectedKeys(orgIds),
                  breadcrumbs: res.data[el],
                  withChildOrgs: organizationState.withChildOrgs,
                })
                this.refreshAlarms()
              }

              if (el === 'orgFilter') {
                this.orgFilterLocal = res.data[el]
                this.$emit('update:orgFilter', res.data[el])
              }

              if (el === 'sortKey') {
                this.$emit('update:sortKey', res.data[el])
                localStorage.setItem('af.my.' + el, JSON.stringify(res.data[el]))
              }

              if (el === 'participantsFilter') {
                this.participantsByPrefix = res.data[el]
                this[el] = res.data[el]
                localStorage.setItem('af.my.' + el, JSON.stringify(res.data[el]))
              }
            })
          }
        })
      }
    },
    applyLocalFilters() {
      const localFilters = loadLocalAlarmFilters(this.filtersPrefix)

      Object.entries(localFilters).forEach(([key, value]) => {
        this[key] = value
      })

      const storedOrgFilter = readAlarmStorage(this.filtersPrefix, 'orgFilter')
      if (storedOrgFilter) {
        this.orgFilterLocal = storedOrgFilter
      }
    },
    saveFilters() {
      if (this.filtersPrefix === 'my') {
        this.handleSaveFilters()
      }
      saveLocalAlarmFilters(this.filtersPrefix, {
        currentPage: this.currentPage,
        sortKey: this.sortKey,
        alarmFilterKey: this.alarmFilterKey,
        alarmFilterValue: this.alarmFilterValue,
        alarmTableRows: this.alarmTableRows,
        alarmFilters: this.alarmFilters,
        orgFilter: this.orgFilterLocal,
        durationFilters: this.durationFilters,
        orderByPriority: this.orderByPriority,
      })
    },
    initSelectParticipantsDlg() {
      this.$refs.pf.hide()
      this.selectParticipantsDlg = true
    },
    handleCheckRow(name) {
      const foundedValue = this.alarmTableValues.find(({value}) => value === name)
      return !!foundedValue?.checked?.length || this.selectedTab === 30;
    },
  },
}
</script>

<style lang="scss" src="./alarm-table-global.scss" />
<style lang="scss" scoped src="./alarm-table.scss" />
